"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Text = require("./Text.styles");
var _typography = require("../../theme/base/typography");
// Create list of commonly used html text elements
const asOptions = Object.freeze({
  bold: 'b',
  strong: 'strong',
  italic: 'i',
  emphasis: 'em',
  small: 'small',
  strikethrough: 's',
  underline: 'u'
});

/**
 * ### `combineAsWithVariant`
 * A function that takes in the `as` value (the HTML element to render the Text component as), and the
 * `variant` value. The default-like styling for the `as` prop is merged with the styling from the
 * `variant` and a combined styleProp object is returned.
 *
 * By default the `as` property only effects the underlying semantics of the markup, whereas the
 * `variant` only effects the visual styling of the text. In order for the text component to be built
 * with accessibility and ease-of-use in mind, these two properties _should_ be interconnected. Having
 * the style and markup unified allows an experience that is accessible to those using screen-readers
 * (or any other assistive technology) that matches (or is at least a close approximation) of the
 * "standard" visual experience.
 *
 * @function combineAsWithVariant
 * @param {string} args.as - The HTML element to render the Text component as
 * @param {string} args.variant - The style variant for the Text component
 * @returns {Object} An object containing the merged styleProps from the `variant` and the `as` props
 */

const combineAsWithVariant = ({
  as,
  variant
}) => {
  const variantFontSizeBase = Number(_Text.variants[`${variant}`].fontSize.base.replace('rem', ''));
  const variantFontSizeDesktop = Number(_Text.variants[`${variant}`].fontSize.desktop.replace('rem', ''));
  let styleProps;
  switch (as) {
    case asOptions.bold:
      styleProps = {
        ..._Text.variants[`${variant}`],
        fontWeight: _typography.fontWeights.semibold
      };
      break;
    case asOptions.strong:
      styleProps = {
        ..._Text.variants[`${variant}`],
        fontWeight: _typography.fontWeights.semibold
      };
      break;
    case asOptions.italic:
      styleProps = {
        ..._Text.variants[`${variant}`],
        fontStyle: 'italic'
      };
      break;
    case asOptions.emphasis:
      styleProps = {
        ..._Text.variants[`${variant}`],
        fontStyle: 'italic'
      };
      break;
    case asOptions.underline:
      styleProps = {
        ..._Text.variants[`${variant}`],
        textDecoration: 'underline'
      };
      break;
    case asOptions.strikethrough:
      styleProps = {
        ..._Text.variants[`${variant}`],
        textDecoration: 'line-through'
      };
      break;
    case asOptions.small:
      styleProps = {
        ..._Text.variants[`${variant}`],
        fontSize: {
          base: `${variantFontSizeBase * 0.8}rem`,
          desktop: `${variantFontSizeDesktop * 0.8}rem`
        }
      };
      break;
    default:
      styleProps = {
        ..._Text.variants[`${variant}`]
      };
      break;
  }
  return styleProps;
};
var _default = exports.default = combineAsWithVariant;